import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = ["src"];
import CulturalBanner from "@/components/cultural-industries/cultural-banner.vue";
import { useMeta } from "vue-meta";
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    useMeta({
      title: "文创周边",
      htmlAttrs: {
        lang: "en",
        amp: true
      },
      meta: [{
        name: "description",
        content: "向幸福学习幸福"
      }, {
        name: "kewords",
        content: "心理学文创周边,正品低价网上商城,全民幸福社"
      }]
    });
    const infoList = ["https://img2.qiuwenxinli.com/official-website/cultural-industries/cultural-info-1.jpg", "https://img2.qiuwenxinli.com/official-website/cultural-industries/cultural-info-2.jpg", "https://img2.qiuwenxinli.com/official-website/cultural-industries/cultural-info-3.jpg", "https://img2.qiuwenxinli.com/official-website/cultural-industries/cultural-info-4.jpg"];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_createVNode(CulturalBanner), (_openBlock(), _createElementBlock(_Fragment, null, _renderList(infoList, (item, index) => {
        return _createElementVNode("div", {
          key: index
        }, [_createElementVNode("img", {
          src: item,
          alt: "",
          style: {
            "vertical-align": "top",
            "width": "100%"
          }
        }, null, 8, _hoisted_1)]);
      }), 64))]);
    };
  }
});